import React, {Component} from 'react';
import {Link} from "react-router-dom";

import './Header.css'
import logo from '../../wb/header_logo.png';
import search_button from '../../wb/change_day.gif';


const header_date = (day) => { 
    const months = [ "January", "February", "March", "April", "May", "June", 
            "July", "August", "September", "October", "November", "December" ];
    const d = new Date(day);
    const day_num = d.getDate();
    let display_date = "" + months[d.getMonth()].substring(0,3) + ' ' + day_num;
    let suffix = '';
    switch (day.charAt(day.length-1)) {        
        case "1":
            suffix = "st";
            break;
        case "2":
            suffix = "nd";
            break;
        case "3":
            suffix = "rd";
            break;            
        default:
            suffix = "th";
            break;
    }  

    return (''+display_date+suffix);
};


class Header extends Component  {
    constructor (props) {
        super(props);
        this.handleDateEdit = this.handleDateEdit.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        // This is only for input field. 
        // It does not update header date displayed with tagline.
        // App holds state for the day to display
        this.state ={dateInput: this.props.day};

    }

    handleDateEdit (e) {
        // TBD: validation/format of date
        this.setState({dateInput:e.target.value})
    }

    handleDateChange (e) {

        // this.props.handleNewDay(e.target.value);
        // TBD: update location url without refresh
        // use preventDefault to prevent browser refresh
        this.props.handleNewDay(this.state.dateInput);

        // 
        e.preventDefault(); 
    }

    render () {
        return (
            <div className='header'>

            <div id="logo_wrapper" className="logo_wrapper" > 
            {/* TBD: remove link. It doesn't make sense for this app to nav home.
                There is only one page. */}
                <a className="logo" href="./"><img alt='logo' src={logo}/></a>
            </div>

            <div className="tagline">
                History of a Day
                <div id="the_day" className="the_day">   
                    {header_date(this.props.day)}
                </div>        				        	
            </div>

            <form id="inputbox"
                className='DateBox'
                name="inputbox"
                action=""
                method="get"
                >
                <div  className="date_filter"> 
                    <input  type="text" className='date_input'
                         size="12" maxLength="10" 
                        name="day" id="day" 
                        value={this.state.dateInput}
                        onChange={this.handleDateEdit}
                        />							    							                 	
                </div>		  
                <div className='search_button_wrapper'>
                <Link to='/' className='search_button'  
                    onClick={this.handleDateChange} 
                    src={search_button}
                    >
                    <img alt='new day' className='search_button' src={search_button}/>
                </Link>

                {/* 
                Alternatives to using LInk
                
                <button type='submit' className='search_button'>
                    <img alt='new day' className='search_button' src={search_button}/>
                </button> 
                
                or 
                
                <input type="button" alt="New Day" 
                        className='search_input_button' 
                        // src={search_button}
                        // value={this.state.dateInput}
                        onClick={this.handleDateChange}
                /> 
                */}
                                        			
                </div>
            </form>

            </div>
    ); //return
    } // render
}; // class

export default Header;